import { render, staticRenderFns } from "./ConsultaSolicitacaoCCS.vue?vue&type=template&id=5aaec80e&"
import script from "./ConsultaSolicitacaoCCS.vue?vue&type=script&lang=js&"
export * from "./ConsultaSolicitacaoCCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports